// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2qolG","errors":"Errors_errors__2VFvI"};